import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ekorg-list-view',
  imports: [],
  templateUrl: './ekorg.list-view.html',
  styleUrls: ['./ekorg.list-view.css'],
})
export class ekorgListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
